import React, { Component } from 'react';
import './Modules.scss';

class SystemDetails extends Component {
  render() {
    var title = this.props.title;
    var data = this.props.data;
    var icon = this.props.icon;
    return (
      <p className="system-details">
          <span className="system-details-label col-4 p-0">{title}:</span> 
          <span className="system-details-value">{data}</span>
      </p>
    );
  }
}

export default SystemDetails;
